import type { NodeDefinition } from "~/nodes/types";

export const cubeNode: NodeDefinition = {
  type: "cube",
  label: "Cube",
  category: "Curves",
  inputs: [
    {
      key: "rad",
      label: "Radius",
      socket: "number",
      control: { kind: "number", key: "rad", label: "rad", step: 1 },
    },
    {
      key: "k",
      label: "K",
      socket: "number",
      control: { kind: "number", key: "k", label: "k", step: 0.1 },
    },
  ],
  outputs: [{ key: "v3", label: "Vector", socket: "vector" }],
  controls: [],
  defaults: { rad: 50, k: 7 },

  compute(ctx) {
    const r = ctx.number("rad", 50);
    const k = ctx.number("k", 7);

    // Superellipsoid normalisation: pushes the spherical sweep out towards a cube.
    const norm = (t: number): number =>
      Math.pow(
        Math.pow(Math.sin(t), 6) *
          (Math.pow(Math.sin(k * t), 6) + Math.pow(Math.cos(k * t), 6)) +
          Math.pow(Math.cos(t), 6),
        1 / 6,
      );

    return {
      v3: {
        x: (t: number) => (r * Math.sin(t) * Math.cos(k * t)) / norm(t),
        y: (t: number) => (r * Math.sin(t) * Math.sin(k * t)) / norm(t),
        z: (t: number) => (r * Math.cos(t)) / norm(t),
      },
    };
  },
};
